import {
  Box,
  Center,
  Text,
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";

function Texts({ texts }) {
  return (
    <Text
      p={{ base: 4, md: 6, xl: 6 }}
      fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
    >
      <Lang text={texts} />
    </Text>
  );
}

export default function AIteensTerms() {
  return (
    <>
      <LineSection />

      <Center>
        <Box
          w={{ base: "xl", md: "full", xl: "6xl" }}
          py={{ base: 20, md: 40 }}
          color={"white"}
        >

          <SectionHeading
            title="Terms and Conditions specific for"
            span="AI-Teens"
          />
          <Box
            mt={{ base: 10, md: 20 }}
          >
            <Texts texts="Must be a teacher or tutor of children up to 17 years old and carry out activities to foster programming skills in robotics or logic processes." />
            <Texts texts="The children involved must belong to a socially vulnerable populations and to a low-incomes household (incomes less than USD$300/month)." />
            <Texts texts="AppOX doesn't give liquid funds or transfer money to the beneficiary  teacher or tutor, AppOX just provides physical resources required for develop activities with the children, such as, devices, accessories, complements, etc." />
            <Texts texts="AppOX will require photos or videos as evidence of the use all resources provided." />
          </Box>
        </Box>
      </Center>
    </>
  );
}